import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";

const FloatingADUWizard = () => {
  const isMobile = useIsMobile();
  
  let theme = "light";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }
  
  const isDark = theme === 'dark';
  
  const buttonStyles = isDark
    ? 'bg-[#0a0a0a] text-[#e4683b] shadow-[8px_8px_16px_#000000,-8px_-8px_16px_#141414] hover:shadow-[10px_10px_20px_#000000,-10px_-10px_20px_#141414]'
    : 'bg-white text-[#e4683b] shadow-[8px_8px_16px_#d8d8d8,-8px_-8px_16px_#ffffff] hover:shadow-[10px_10px_20px_#d0d0d0,-10px_-10px_20px_#ffffff]';

  if (isMobile) {
    return (
      <div className="fixed bottom-4 right-4 z-50">
        <Link 
          to="/what-fits-my-lot" 
          className={`px-4 py-2 rounded-xl font-medium transition-all duration-300 no-underline inline-block ${buttonStyles}`}
        >
          What fits my lot?
        </Link>
      </div>
    );
  }

  // Desktop version
  return (
    <div className="fixed bottom-8 right-8 z-50">
      <Link 
        to="/what-fits-my-lot" 
        className={`rounded-xl font-medium transition-all duration-300 no-underline inline-block px-[29px] py-[17px] ${buttonStyles}`}
      >
        What fits my lot?
      </Link>
    </div>
  );
};

export default FloatingADUWizard;
